import React, { useState } from 'react';
import './TabPanel.css';

interface Tab {
  id: string;
  label: string;
  icon?: React.ReactNode;
  badge?: number;
}

interface TabPanelProps {
  tabs: Tab[];
  activeTab?: string;
  onTabChange?: (tabId: string) => void;
  children: React.ReactNode;
  className?: string;
}

function TabPanel({ tabs, activeTab: controlledTab, onTabChange, children, className }: TabPanelProps) {
  const [internalTab, setInternalTab] = useState(tabs[0]?.id || '');
  const activeTab = controlledTab ?? internalTab;

  const handleTabClick = (tabId: string) => {
    if (onTabChange) {
      onTabChange(tabId);
    } else {
      setInternalTab(tabId);
    }
  };

  return (
    <div className={`tab-panel ${className || ''}`}>
      <div className="tab-panel-header">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`tab-panel-tab ${activeTab === tab.id ? 'tab-active' : ''}`}
            onClick={() => handleTabClick(tab.id)}
          >
            {tab.icon && <span className="tab-icon">{tab.icon}</span>}
            <span className="tab-label">{tab.label}</span>
            {tab.badge !== undefined && tab.badge > 0 && (
              <span className="tab-badge">{tab.badge}</span>
            )}
          </button>
        ))}
      </div>
      <div className="tab-panel-content">
        {children}
      </div>
    </div>
  );
}

export default TabPanel;
